import { getQueryParam } from '../../core/utils/url';
import { getEventId } from '../services/storage';

const extractEventId = (stateEventId) => {
    if (stateEventId) {
        return stateEventId;
    }

    const queryEventId = getQueryParam(window.location.href, 'eventId');
    if (queryEventId) {
        return queryEventId;
    }

    return getEventId();
};

export default extractEventId;
